var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 1.16797V7.0013C8.75033 7.64297 8.22533 8.16797 7.58366 8.16797H1.16699V4.4463C1.59283 4.9538 2.24617 5.2688 2.96951 5.2513C3.55867 5.23964 4.08949 5.01214 4.48616 4.63297C4.66699 4.4813 4.81867 4.2888 4.93534 4.0788C5.14534 3.72296 5.26199 3.30295 5.25033 2.86545C5.23283 2.18295 4.9295 1.58214 4.457 1.16797H8.75033Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8337 8.16797V9.91797C12.8337 10.8863 12.052 11.668 11.0837 11.668H10.5003C10.5003 11.0263 9.97533 10.5013 9.33366 10.5013C8.69199 10.5013 8.16699 11.0263 8.16699 11.668H5.83366C5.83366 11.0263 5.30866 10.5013 4.66699 10.5013C4.02533 10.5013 3.50033 11.0263 3.50033 11.668H2.91699C1.94866 11.668 1.16699 10.8863 1.16699 9.91797V8.16797H7.58366C8.22533 8.16797 8.75033 7.64297 8.75033 7.0013V2.91797H9.82367C10.2437 2.91797 10.6287 3.14547 10.8387 3.50714L11.8361 5.2513H11.0837C10.7628 5.2513 10.5003 5.5138 10.5003 5.83464V7.58464C10.5003 7.90547 10.7628 8.16797 11.0837 8.16797H12.8337Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 12.8333C5.311 12.8333 5.83333 12.311 5.83333 11.6667C5.83333 11.0223 5.311 10.5 4.66667 10.5C4.02233 10.5 3.5 11.0223 3.5 11.6667C3.5 12.311 4.02233 12.8333 4.66667 12.8333Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 12.8333C9.97799 12.8333 10.5003 12.311 10.5003 11.6667C10.5003 11.0223 9.97799 10.5 9.33366 10.5C8.68933 10.5 8.16699 11.0223 8.16699 11.6667C8.16699 12.311 8.68933 12.8333 9.33366 12.8333Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 7V8.16667H11.0833C10.7625 8.16667 10.5 7.90417 10.5 7.58333V5.83333C10.5 5.5125 10.7625 5.25 11.0833 5.25H11.8358L12.8333 7Z",
    stroke: "#292D32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24967 2.91536C5.24967 3.61536 4.94052 4.23953 4.45635 4.66536C4.04218 5.02703 3.50551 5.2487 2.91634 5.2487C1.62717 5.2487 0.583008 4.20453 0.583008 2.91536C0.583008 2.18036 0.921341 1.5212 1.45801 1.09537C1.86051 0.774534 2.36801 0.582031 2.91634 0.582031C4.20551 0.582031 5.24967 1.6262 5.24967 2.91536Z",
    stroke: "#292D32",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.06217 2.1875V3.0625L2.33301 3.5",
    stroke: "#292D32",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTime);
export default __webpack_public_path__ + "static/media/truck-time.5b369a4a212dcaa598b77d67c7aae319.svg";
export { ForwardRef as ReactComponent };